import { FormControlLabel, FormGroup } from "@mui/material";
import styles from "./groupCard.module.scss";
import { Group } from "src/page/group/groupSlice";
import { ChangeEvent, useState } from "react";
import { useAppSelector } from "src/page/store";
import IOSSwitch from "src/components/SettingCard/IOSSwitch";
import {
  activeStatusMapping,
  EMPTY_STRING,
  groupTypeMapping,
  reverseActiveStatusMapping
} from "src/components/constant/constant";
import { toggleGroupStatus } from "src/network/graphql/groupService";
import { immediateToast } from "izitoast-react";
import swal from "sweetalert2";
import { groupColors } from "src/variable/randomColor";
import { GroupDetail } from "src/page/groupDetail/groupDetailSlice";
import { Link } from "react-router-dom";

interface GroupCardProp {
  data: Group | GroupDetail;
  reloadList?: () => void;
}

export default function GroupCard({ data, reloadList }: GroupCardProp) {
  const { userInfo } = useAppSelector((state) => state.auth);

  const [isActiveChecked, setIsActiveChecked] = useState<boolean>(activeStatusMapping[data?.group_status]);

  const handleActiveToggle = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;

    swal
      .fire({
        title: `Are you sure! you want to ${reverseActiveStatusMapping[String(isChecked)].toLowerCase()} ${data?.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#1e293b",
        confirmButtonText: "Yes",
        customClass: {
          popup: "swal2-popup-custom"
        }
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          setIsActiveChecked(isChecked);
          if (data?.group_id) {
            const response = await toggleGroupStatus(data?.group_id, isChecked);

            if (response.data.errors) {
              setIsActiveChecked(!isChecked);
            } else {
              immediateToast("success", {
                message: `${data?.name} is ${response.data.toggle_group_status.group_status.toLowerCase()}`,
                timeout: 3000,
                position: "topCenter"
              });
              setIsActiveChecked(activeStatusMapping[response.data.toggle_group_status.group_status]);
              if (reloadList) reloadList();
            }
          }
        }
      });
  };

  return (
    <div className={styles.groupCard}>
      <Link className={styles.card} to={`/groups/${data?.group_id}`}>
        <div className={styles.grpHolder}>
          <h2>{data?.name}</h2>
        </div>

        <div className={styles.owner}>
          <span className={styles.heading}>Owner : </span>
          <span className={styles.value}>{userInfo?.fullName}</span>
        </div>

        <div className={styles.type}>
          <span className={styles.heading}>Type : </span>
          <div
            className={styles.role}
            style={{
              backgroundColor: `${groupColors[data?.group_type]}33`,
              borderColor: `${groupColors[data?.group_type]}73`,
              color: `${groupColors[data?.group_type]}FF`
            }}
          >
            {groupTypeMapping[data?.group_type]}
          </div>
        </div>

        <div className={styles.active}>
          <label className={styles.heading}> Active :</label>
          <FormGroup className={styles.formGroup} style={{ paddingTop: "4px", marginLeft: "4px" }}>
            <FormControlLabel
              className={styles.formControlLabel}
              control={<IOSSwitch sx={{ m: 1 }} checked={isActiveChecked} onChange={handleActiveToggle} />}
              label={EMPTY_STRING}
              aria-label="active"
            />
          </FormGroup>
        </div>

        {/* <div className={styles.particpant}>
            <span className={styles.heading}>Particpants :</span>
            <AvatarGroup
              onClick={() => setModalType("EDIT")}
              sx={{
                cursor: "pointer",
                "& .MuiAvatar-root": {
                  width: 24,
                  height: 24,
                  fontSize: "12px"
                }
              }}
            >
              <Avatar sx={{ bgcolor: "#fb837a" }}>S</Avatar>
              <Avatar sx={{ bgcolor: "#1e293b" }}>P</Avatar>
              <Avatar sx={{ bgcolor: "#ffa352" }}>E</Avatar>
              <Avatar sx={{ bgcolor: "#4f3466" }}>D</Avatar>
            </AvatarGroup>
            <div className={styles.totalCount} onClick={() => setModalType("EDIT")}>
              +12 more
            </div>
          </div>

          <div className={styles.staff}>
            <span className={styles.heading}>Staff :</span>
            <AvatarGroup
              sx={{
                cursor: "pointer",
                "& .MuiAvatar-root": {
                  width: 24,
                  height: 24,
                  fontSize: "12px"
                }
              }}
            >
              <Avatar sx={{ bgcolor: "#edd971" }}>A</Avatar>
              <Avatar sx={{ bgcolor: "#708597" }}>B</Avatar>
              <Avatar sx={{ bgcolor: "#58af53" }}>L</Avatar>
              <Avatar sx={{ bgcolor: "#00539c" }}>E</Avatar>
            </AvatarGroup>
            <div className={styles.totalCount} onClick={() => setModalType("EDIT")}>
              +12 more
            </div>
          </div> */}
      </Link>
    </div>
  );
}
